<template>
  <step-section
    :title="$t('profile')"
    :loading="loading$"
    :step-number="getStepNumber('profile')"
  >
    <div class="row row--custom">
      <div
        class="col-12 col-xs-6 col-md-6--custom col-item-3 col-margin"
        v-for="profile in profiles"
        :key="profile.id"
      >
        <profile-block
          v-bind="profile"
          :checked="isItemChecked('profile.id', profile.id)"
          @click="() => handleItemClick(profile)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import ProfileBlock from '@/components/blocks/ProfileBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'ProfileStep',
    mixins: [stepMixin],
    props: {
      profiles: Array,
    },
    methods: {
      handleItemClick(profile) {
        this.updateFormField({
          field: 'profile',
          value: {
            id: profile.id,
            name: profile.name,
          },
        });
      },
    },
    components: {
      ProfileBlock,
    },
  };
</script>
